export { default as Cart } from "../../static/img/svg/cart.svg";
export { default as ArrowRight } from "../../static/img/svg/arrow__right.svg";
export { default as RealCvltvreIcon } from "../../static/img/svg/real_cvltvre_icon.svg";
export { default as RealCvltvreLogo } from "../../static/img/svg/real_cvltvre_logo.svg";
